module.exports = __webpack_public_path__ + "static/media/sensorGroup.073c9cea.svg";